import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg
      id="prefix__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 57.14 53.86"
      xmlSpace="preserve"
      {...props}
    >
      <style>{`.prefix__st1{fill:${props.fillPrimary}}`}</style>
      <path
        id="prefix__Rectangle_471"
        d="M20.41 2.25h15.52c9.52 0 17.24 7.72 17.24 17.24v15.52c0 9.52-7.72 17.24-17.24 17.24H20.41c-9.52 0-17.24-7.72-17.24-17.24V19.49c0-9.52 7.72-17.24 17.24-17.24z"
        fill={props.fillSecondary}
      />
      <g id="prefix__Group_2029" transform="translate(-228.236 -227.495)">
        <path
          id="prefix__Path_5511"
          className="prefix__st1"
          d="M245.93 239.7c.54.2.89.73.84 1.3 0 .42.07.83.12 1.27l-5.34.5c-.07-.64-.1-1.29-.09-1.94.08-.49.5-.85.99-.84l2.66-.24c.07-.01.13-.03.19-.05h.63z"
        />
        <path
          id="prefix__Path_5512"
          className="prefix__st1"
          d="M267.49 239.7c.47.06.95.12 1.42.17.47.06.96.09 1.43.13.59.02 1.06.51 1.04 1.1 0 .03 0 .06-.01.08 0 .13-.01.25-.03.38-.04.39-.08.78-.12 1.21l-5.34-.5c.08-.64.14-1.27.25-1.89.07-.37.41-.52.71-.69l.65.01z"
        />
        <path
          id="prefix__Path_5513"
          className="prefix__st1"
          d="M262.28 263.71c-.36.29-.7.56-1.06.82a.36.36 0 01-.27.02 11.014 11.014 0 01-8.02-8.34c-.52-2.15-.37-4.4.43-6.46.06-.25.27-.43.52-.47.19-.04.37-.1.58-.15-.01.09-.02.19-.02.28 0 .23.16.44.39.49.21.07.45-.02.57-.2.07-.08.12-.18.14-.29.1-.42.36-.53.77-.52 1.05.01 2.08.21 3.07.57 2.22.78 4 2.48 4.88 4.67a8.38 8.38 0 01-.97 8.41c-.06.15-.23.22-.38.17-.16-.04-.33-.06-.49-.08a.543.543 0 00-.64.41c-.06.26.09.53.35.62l.15.05zm-4.5-3.32c-.04-.13-.1-.26-.17-.38-.42-.53-.84-1.05-1.27-1.57a.514.514 0 00-.69-.1c-.24.14-.32.44-.18.68 0 0 0 .01.01.01.44.58.9 1.16 1.39 1.7.17.11.37.13.56.06.14-.05.23-.26.35-.4zm-3.28-5.72c-.37 0-.65.27-.57.59.17.69.39 1.38.63 2.07.1.25.39.36.63.26.01-.01.02-.01.04-.02.26-.1.39-.39.3-.65-.18-.61-.37-1.23-.56-1.84a.5.5 0 00-.47-.41zm-.79-1.93h.02c-.01.19-.01.37 0 .56.03.28.28.48.55.45.07-.01.14-.03.2-.06a.62.62 0 00.31-.59c.04-.53.08-1.07.14-1.6.05-.42-.09-.69-.42-.74-.33-.05-.58.15-.64.57-.06.46-.11.94-.16 1.41zm7.26 9.7c-.06-.07-.13-.26-.27-.34-.56-.33-1.14-.64-1.72-.95a.517.517 0 00-.69.19c-.16.22-.11.52.11.68l.01.01c.61.36 1.23.71 1.87 1.02.32.14.68-.15.69-.61z"
        />
        <path
          id="prefix__Path_5514"
          className="prefix__st1"
          d="M265.8 243.34l5.33.5c-.04.49-.08.97-.13 1.44-.25 2.67-.5 5.34-.76 8.01-.27 2.81-.53 5.61-.8 8.42-.24 2.49-.47 4.99-.71 7.48-.04.44-.22.59-.67.59h-4.02c-.51 0-.71-.2-.66-.7.14-1.57.31-3.14.43-4.71.05-.56.25-1.09.58-1.55a9.495 9.495 0 00.64-9.66.973.973 0 01-.1-.47c.22-2.38.45-4.76.67-7.13.06-.73.13-1.45.2-2.22z"
        />
        <path
          id="prefix__Path_5515"
          className="prefix__st1"
          d="M246.99 243.34c.14 1.45.27 2.87.41 4.28l.45 4.76c.04.33-.02.66-.15.96a9.529 9.529 0 001.03 9.96c.09.12.16.27.18.42.17 1.78.34 3.57.5 5.34.04.5-.15.72-.64.72h-4.02c-.48 0-.65-.16-.69-.64-.27-2.81-.53-5.63-.8-8.45-.23-2.39-.45-4.77-.67-7.16-.22-2.39-.45-4.77-.69-7.16-.08-.84-.15-1.67-.23-2.54l5.32-.49z"
        />
        <path
          id="prefix__Path_5516"
          className="prefix__st1"
          d="M249.84 251.97c.54.26.83.12.96-.48.13-.68.64-1.22 1.31-1.39-1.92 6.28 1.42 12.97 7.6 15.2l.01.09c-.59.16-1.18.35-1.77.46-.18.03-.41-.16-.61-.26-.59-.3-.82-.21-1.03.4-4.71-.02-8.51-3.86-8.49-8.58.01-1.98.72-3.91 2.02-5.44zm-.4 2.65h-.03c.07.63.13 1.26.22 1.9.04.27.29.45.56.41h.02c.28-.04.47-.28.46-.56-.05-.8-.11-1.6-.17-2.4 0-.29-.24-.53-.53-.53s-.53.24-.53.53c-.01.21 0 .43 0 .65zm1.43 3.59c-.51 0-.78.36-.62.74.32.75.67 1.5 1.03 2.23.13.26.44.36.69.24.01-.01.02-.01.04-.02.25-.14.35-.46.21-.71-.33-.72-.65-1.44-1-2.15-.08-.16-.27-.26-.35-.33zm4.59 6.43c-.06-.14-.13-.28-.22-.41-.56-.57-1.14-1.13-1.71-1.69a.51.51 0 00-.73-.03l-.01.01c-.21.17-.24.49-.07.7l.01.01c.6.62 1.21 1.22 1.84 1.8.16.09.36.1.54.03.15-.07.23-.27.35-.42z"
        />
        <path
          id="prefix__Path_5517"
          className="prefix__st1"
          d="M253.72 248.2v-4.64h5.32v4.64c-1.74-.5-3.58-.5-5.32 0z"
        />
        <path
          id="prefix__Path_5518"
          className="prefix__st1"
          d="M259.07 266.73c0 .86.01 1.71 0 2.55 0 .28-.22.5-.5.5h-.04c-1.42.01-2.84.01-4.26 0-.27 0-.52-.14-.52-.42-.03-.86-.01-1.73-.01-2.63 1.74.49 3.59.49 5.33 0z"
        />
        <path
          id="prefix__Path_5519"
          className="prefix__st1"
          d="M259.09 242.46h-5.31c-.03-.62-.02-1.24.02-1.86.08-.5.53-.85 1.03-.81 1.09 0 2.17.01 3.26.04.53.01.97.43 1 .97.01.53 0 1.08 0 1.66z"
        />
      </g>
    </svg>
  );
}

export default SvgComponent;
